import { Star } from "lucide-react";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-label="Google">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const AVATAR_COLORS = [
  "bg-[#336DBF]", "bg-[#34A853]", "bg-[#EA4335]", "bg-[#FBBC05]",
  "bg-[#9333EA]", "bg-[#06B6D4]", "bg-[#F97316]", "bg-[#EC4899]",
];

function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("fr-CH", { year: "numeric", month: "long" });
  } catch {
    return dateStr;
  }
}

export default function GoogleReviewCard({ avis, index = 0 }) {
  const auteur = avis.auteur || avis.prenom || "Client";
  const initial = auteur.charAt(0).toUpperCase();
  const color = AVATAR_COLORS[index % AVATAR_COLORS.length];

  return (
    <div className="bg-white rounded-xl border border-[#062133]/8 p-5 sm:p-6 flex flex-col h-full" data-testid={`review-card-${index}`}>
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-9 h-9 rounded-full ${color} flex items-center justify-center text-white font-semibold text-sm shrink-0`}>
          {initial}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-[#062133] text-sm truncate">{auteur}</p>
          <div className="flex items-center gap-1.5">
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map(i => (
                <Star key={i} size={12} className={i <= avis.note ? "text-amber-400 fill-amber-400" : "text-gray-200 fill-gray-200"} />
              ))}
            </div>
            {avis.date && <span className="text-[11px] text-[#062133]/40">{formatDate(avis.date)}</span>}
          </div>
        </div>
        <div className="shrink-0 ml-auto" title="Avis Google vérifié">
          <GoogleIcon />
        </div>
      </div>
      <p className="text-[#062133]/70 text-sm leading-relaxed flex-1">{avis.commentaire}</p>
      {avis.reponse && (
        <div className="mt-3 pt-3 border-t border-[#062133]/5">
          <p className="text-[11px] font-semibold text-[#336DBF] mb-1">Réponse de Nettoyage Expert</p>
          <p className="text-[11px] text-[#062133]/50 leading-relaxed">{avis.reponse}</p>
        </div>
      )}
    </div>
  );
}
